import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t(_t) {
    _classCallCheck(this, t);

    this._array = [], _t <= 0 && console.error("strideInBytes must be positive!"), this._stride = _t;
  }

  _createClass(t, [{
    key: "array",
    get: function get() {
      return this._array;
    }
  }, {
    key: "index",
    get: function get() {
      return 4 * this._array.length / this._stride;
    }
  }, {
    key: "itemSize",
    get: function get() {
      return this._stride;
    }
  }, {
    key: "sizeInBytes",
    get: function get() {
      return 4 * this._array.length;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.array.length = 0;
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return new Uint32Array(this._array).buffer;
    }
  }], [{
    key: "i1616to32",
    value: function i1616to32(_t2, r) {
      return 65535 & _t2 | r << 16;
    }
  }, {
    key: "i8888to32",
    value: function i8888to32(_t3, r, e, s) {
      return 255 & _t3 | (255 & r) << 8 | (255 & e) << 16 | s << 24;
    }
  }, {
    key: "i8816to32",
    value: function i8816to32(_t4, r, e) {
      return 255 & _t4 | (255 & r) << 8 | e << 16;
    }
  }]);

  return t;
}();

export { t as default };